import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ROUTE } from '@portal/data-access';
import { SigningStore } from '@portal/signing/data-access';
import { PortalVerificationStore, VerificationApiService, verifiedGuard } from '@portal/verification/data-access';
import { RedirectGuard } from '@core/data-access';

const routerConfig: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  initialNavigation: 'enabledBlocking',
};

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE.VERIFICATION.MAIN,
  },
  {
    path: 'flexipay',
    canActivate: [RedirectGuard],
    loadChildren: () => import('./redirect-flexipay.module').then(m => m.RedirectFlexiPayModule),
  },
  {
    path: ROUTE.VERIFICATION.MAIN,
    loadChildren: () => import('@portal/verification/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.SINGPASS.MAIN,
    loadChildren: () => import('@portal/singpass/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.APPLICATION.MAIN,
    canActivate: [verifiedGuard],
    loadChildren: () => import('@portal/application/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.BROKER.MAIN,
    loadChildren: () => import('@portal/broker/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.SIGNING.MAIN,
    loadChildren: () => import('@portal/signing/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.CBS_CONSENT.MAIN,
    loadChildren: () => import('@portal/cbs-consent/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.INDIVIDUAL.MAIN,
    loadChildren: () => import('@portal/individual/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.ERROR.MAIN,
    loadChildren: () => import('@portal/shared/error-page').then(m => m.ErrorPageModule),
  },
  {
    path: '**',
    canActivate: [RedirectGuard],
    data: { code: '404' },
    loadComponent: () => import('@portal/shared/error-page').then(m => m.ErrorPageComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerConfig)],
  exports: [RouterModule],
  providers: [PortalVerificationStore, SigningStore, VerificationApiService],
})
export class AppRoutingModule {}
